module.exports = __webpack_public_path__ + "static/media/legendary_gem_small.60d2f3cd.png";